import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV_LINKS = [
  { to: '/', label: 'Accueil' },
  { to: '/a-propos', label: 'À propos' },
  { to: '/intelligence-economique', label: 'Intelligence Économique' },
  { to: '/publications', label: 'Publications' },
  { to: '/actualites', label: 'Actualités' },
  { to: '/abonnements', label: 'Abonnements' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="site-header">
      <div className="container header-bar">
        <Link to="/" className="brand">
          <img src="/images/logo-aeii.jpg" alt="Logo AEII" className="brand-logo" />
          <span>
            AEII
            <small>Africa Economic Intelligence Institute</small>
          </span>
        </Link>

        <nav className={`main-nav ${menuOpen ? 'open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="header-actions">
          <div id="authArea">
            {user ? (
              <div className="user-chip">
                <span className={`plan-badge ${user.plan}`}>{user.plan}</span>
                <Link to="/mon-compte" className="account-link">
                  {user.full_name ? user.full_name.split(' ')[0] : 'Mon compte'}
                </Link>
                <button onClick={handleLogout} title="Déconnexion">
                  <i className="fa-solid fa-right-from-bracket"></i>
                </button>
              </div>
            ) : (
              <>
                <Link to="/connexion" className="btn btn-outline btn-sm">
                  Connexion
                </Link>
                <Link to="/inscription" className="btn btn-primary btn-sm">
                  S'inscrire
                </Link>
              </>
            )}
          </div>
          <button
            className="nav-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Ouvrir le menu"
          >
            <i className="fa-solid fa-bars"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;